// import login from 'Views/User/Login'
// import login from 'Components/Dynamic/kh/User/Login/index'
import register from 'Views/User/Register'
import resetPassword from 'Views/User/ResetPwd'
import firstStep from 'Views/User/ResetPwd/first-step'
import secondStep from 'Views/User/ResetPwd/second-step'
import thirdStep from 'Views/User/ResetPwd/third-step'
import Invitation from 'Views/User/Invitation'
export default [
  {
    name: 'user',
    path: '/',
    redirect: '/home'
  },
  // {
  // 	name: 'login',
  // 	path: '/login',
  // 	component: login,
  // 	meta: {
  // 		include: [],
  // 		index: 0
  // 	}
  // },
  {
    name: 'register',
    path: '/register',
    component: register,
    meta: {
      include: [],
      index: 1
    }
  },
  {
    name: 'resetPassword',
    path: '/resetPassword',
    component: resetPassword,
    redirect: '/resetPassword/firstStep',
    meta: {
      include: [],
      index: 0
    },
    children: [
      {
        name: 'firstStep',
        path: '/resetPassword/firstStep',
        component: firstStep,
        meta: {
          include: [],
          index: 0
        }
      },
      {
        name: 'secondStep',
        path: '/resetPassword/secondStep',
        component: secondStep,
        meta: {
          include: [],
          index: 0
        }
      },
      {
        name: 'thirdStep',
        path: '/resetPassword/thirdStep',
        component: thirdStep,
        meta: {
          include: [],
          index: 0
        }
      }
    ]
  },
  {
    name: 'Invitation',
    path: '/Invitation',
    component: Invitation,
    meta: {
      include: [],
      index: 0
    }
  },
]
